import { ActivityCatalogItem, ProjectAttributes } from '../../models';
import { DEFAULT_CATALOG, PROJECT_ATTRS_SEED } from '../prototype/project-settings-data';

/** Managed project attribute lists — from the prototype PROJECT_ATTRS_SEED. */
export const PROJECT_ATTRIBUTES_SEED: ProjectAttributes = {
  types: [...PROJECT_ATTRS_SEED.types],
  delivery: [...PROJECT_ATTRS_SEED.delivery],
  contracts: [...PROJECT_ATTRS_SEED.contracts],
  trades: [...PROJECT_ATTRS_SEED.trades],
  states: [...PROJECT_ATTRS_SEED.states],
  sizeTiers: (PROJECT_ATTRS_SEED.sizeTiers as any[]).map((t) => ({ name: t.name, min: t.min })),
};

/** CPM activity catalog — from the prototype DEFAULT_CATALOG (built from ACTIVITY_TEMPLATE). */
export const ACTIVITY_CATALOG_SEED: readonly ActivityCatalogItem[] = (DEFAULT_CATALOG as any[]).map(
  (c): ActivityCatalogItem => ({ id: c.id, code: c.code ?? '', name: c.name ?? '', w: c.w ?? 0 }),
);
